import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { defaultSeasonRosterExportFieldNames } from "~pages/Roster/SeasonRosterListPage/constants/exportFields.ts";
import type { DefaultOperationSuccessResponse } from "~types/response.ts";

export const useExportSeasonRoster = (entityId: string) => {
  const { sport = "", organizationId = "", seasonId = "" } = useParams();
  const request = useApi();

  return useMutation<DefaultOperationSuccessResponse, Error, Array<string>>({
    mutationFn: async (fieldNames: Array<string>) => {
      const body = {
        fieldNames: fieldNames || defaultSeasonRosterExportFieldNames,
      };

      return await request(`${sport}/o/${organizationId}/seasons/${seasonId}/entities/${entityId}/roster/export`, {
        method: "POST",
        body,
      });
    },
  });
};
